import React, { useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AdminOperations.css";
import { subirNoticias } from "./constants";

const obtenerFechaActual = () => {
  const fechaActual = new Date();
  const desfaseHorario = fechaActual.getTimezoneOffset() * 60000;
  return new Date(fechaActual.getTime() - desfaseHorario)
    .toISOString()
    .split("T")[0];
};

const CreateNews = () => {
  const [titulo, setTitulo] = useState("");
  const [contenido, setContenido] = useState("");
  const [imagen, setImagen] = useState(null);
  const [fechaExpiracion, setFechaExpiracion] = useState("");
  const [url, setUrl] = useState("");
  const [estaGuardando, setEstaGuardando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const peticionEnProceso = useRef(false);
  const inputImagen = useRef(null);
  const navigate = useNavigate();
  const fechaMinima = obtenerFechaActual();

  const limpiarFormulario = () => {
    setTitulo("");
    setContenido("");
    setImagen(null);
    setFechaExpiracion("");
    setUrl("");
    if (inputImagen.current) {
      inputImagen.current.value = "";
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (peticionEnProceso.current) {
      return;
    }

    if (fechaExpiracion < fechaMinima) {
      setResultado({
        tipo: "warning",
        mensaje:
          "La fecha de vencimiento no puede ser anterior a la fecha de hoy.",
      });
      return;
    }

    peticionEnProceso.current = true;
    setEstaGuardando(true);
    setResultado(null);

    try {
      const formData = new FormData();
      formData.append("titulo", titulo.trim());
      formData.append("contenido", contenido.trim());
      formData.append("imagen", imagen);
      formData.append("fecha_expiracion", fechaExpiracion);
      formData.append("url", url.trim());

      const response = await axios.post(subirNoticias, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setResultado({
        tipo: "success",
        mensaje: response.data?.message || "La noticia se creó correctamente.",
      });
      limpiarFormulario();
    } catch (error) {
      console.error("Error al crear la noticia:", error);
      setResultado({
        tipo: "error",
        mensaje:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "No fue posible crear la noticia.",
      });
    } finally {
      peticionEnProceso.current = false;
      setEstaGuardando(false);
    }
  };

  return (
    <div className="admin-operation-page">
      <main className="admin-operation-container admin-operation-container-narrow">
        <header className="admin-operation-header">
          <p className="admin-operation-eyebrow">Comunicación institucional</p>
          <h1>Crear noticia</h1>
          <p>
            Publica un aviso con imagen y vigencia. Puedes agregar un enlace
            externo únicamente cuando necesites ampliar la información.
          </p>
        </header>

        <form className="admin-operation-panel" onSubmit={handleSubmit}>
          <div className="admin-operation-form-grid">
            <div className="admin-operation-field admin-operation-field-wide">
              <label htmlFor="news-title">Título</label>
              <input
                id="news-title"
                type="text"
                value={titulo}
                onChange={(event) => setTitulo(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field admin-operation-field-wide">
              <label htmlFor="news-content">Contenido</label>
              <textarea
                id="news-content"
                value={contenido}
                onChange={(event) => setContenido(event.target.value)}
                disabled={estaGuardando}
                required
              />
              <small>
                Explica brevemente la información más importante para el
                usuario.
              </small>
            </div>

            <div className="admin-operation-field">
              <label htmlFor="news-image">Imagen</label>
              <input
                ref={inputImagen}
                className="admin-operation-file"
                id="news-image"
                type="file"
                accept="image/*"
                onChange={(event) => setImagen(event.target.files[0] || null)}
                disabled={estaGuardando}
                required
              />
              {imagen && <small>Imagen seleccionada: {imagen.name}</small>}
            </div>

            <div className="admin-operation-field">
              <label htmlFor="news-expiration">Fecha de vencimiento</label>
              <input
                id="news-expiration"
                type="date"
                value={fechaExpiracion}
                min={fechaMinima}
                onChange={(event) => setFechaExpiracion(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field admin-operation-field-wide">
              <label htmlFor="news-url">Enlace externo (opcional)</label>
              <input
                id="news-url"
                type="url"
                placeholder="https://ejemplo.com"
                value={url}
                onChange={(event) => setUrl(event.target.value)}
                disabled={estaGuardando}
              />
              <small>
                Déjalo vacío si la noticia no necesita dirigir al usuario a
                otra página.
              </small>
            </div>
          </div>

          {resultado && (
            <div
              className={`admin-operation-status admin-operation-status-${resultado.tipo}`}
              role="status"
              aria-live="polite"
            >
              {resultado.mensaje}
            </div>
          )}

          <div className="admin-operation-actions">
            <button
              className="admin-operation-button"
              type="submit"
              disabled={estaGuardando}
            >
              {estaGuardando ? "Publicando noticia..." : "Crear noticia"}
            </button>
            <button
              className="admin-operation-button admin-operation-button-secondary"
              type="button"
              onClick={() => navigate("/admin-home")}
              disabled={estaGuardando}
            >
              Regresar al inicio
            </button>
          </div>
        </form>
      </main>
    </div>
  );
};

export default CreateNews;
